import { postCopyWager } from '../api/postCopyWager';
import {setGetUserById} from './setGetUserById';

const setPostCopyWager = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCopyWager(params);
            dispatch(setGetUserById(params.id));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCopyWager
}